import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withInterceptors} from '@angular/common/http'
import localeSv from '@angular/common/locales/sv'
import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {provideRouter, withHashLocation, withInMemoryScrolling} from '@angular/router'
import {authInterceptor, responseInterceptor} from '@sparbanken-syd/sparbanken-syd-bankid'
import {routes} from './app.routes'
import {WINDOW} from './application/app'
import {routeInitializer} from './application/route-initializer'
import {RouteService} from './services/route.service'

registerLocaleData(localeSv)
export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: false,
        appearance: 'outline',
        subscriptSizing: 'dynamic'
      }
    },
    {provide: WINDOW, useValue: window},
    provideAppInitializer(() => {
      routeInitializer(inject(RouteService), inject(WINDOW))
    }),
    provideRouter(routes, withHashLocation(), withInMemoryScrolling({anchorScrolling: 'enabled'})),
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    )
  ]
}